import { createAction, props } from '@ngrx/store'
import { VouchersEntity } from './vouchers.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadVouchers = createAction('[Vouchers/API] Load Vouchers')
export const loadVouchersSuccess = createAction(
  '[Vouchers/API] Load Vouchers Success',
  props<{ vouchers: VouchersEntity[] }>(),
)

export const loadVouchersFailure = createAction(
  '[Vouchers/API] Load Vouchers Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const updateSelectedVoucher = createAction(
  '[Vouchers/API] Update Selected Voucher ID',
  props<{ voucherId: string }>(),
)

export const sendVoucherEmail = createAction('[Vouchers/API] Send Voucher Email', props<{ email: string }>())

export const sendVoucherEmailSuccess = createAction('[Vouchers/API] Send Voucher Email Success')

export const sendVoucherEmailFailure = createAction(
  '[Vouchers/API] Send Voucher Email Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const clearVouchers = createAction('[Vouchers/API] Clear Vouchers')

export const downloadVoucherPdf = createAction(
  '[Vouchers/API] Download Voucher PDF',
  props<{ voucher: VouchersEntity }>(),
)

export const downloadVoucherPdfSuccess = createAction(
  '[Vouchers/API] Download Voucher Success',
  props<{ voucher: Blob }>(),
)

export const downloadVoucherPdfFailure = createAction(
  '[Vouchers/API] Download Voucher Failure',
  props<{ error: HttpErrorResponse }>(),
)
